/**
 * 타입드 이벤트 버스 (contracts/game-events.md).
 * 동기 발행, 핸들러 예외 격리(버스 중단 없음). 상태관리 라이브러리 없이 이 버스로 조립.
 */
import type { GameEvents } from './types';

type Handler<K extends keyof GameEvents> = (payload: GameEvents[K]) => void;
type AnyHandler = (payload: unknown) => void;

export class EventBus {
  private listeners = new Map<keyof GameEvents, Set<AnyHandler>>();

  on<K extends keyof GameEvents>(type: K, handler: Handler<K>): () => void {
    let set = this.listeners.get(type);
    if (!set) {
      set = new Set<AnyHandler>();
      this.listeners.set(type, set);
    }
    set.add(handler as AnyHandler);
    return () => this.off(type, handler);
  }

  off<K extends keyof GameEvents>(type: K, handler: Handler<K>): void {
    this.listeners.get(type)?.delete(handler as AnyHandler);
  }

  emit<K extends keyof GameEvents>(type: K, payload: GameEvents[K]): void {
    const set = this.listeners.get(type);
    if (!set) return;
    // 순회 중 구독 변경에 안전하도록 스냅샷 사용.
    for (const handler of [...set]) {
      try {
        handler(payload);
      } catch (err) {
        console.warn(`[EventBus] handler error for "${String(type)}":`, err);
      }
    }
  }
}
